<template>
    <div class=" container-fluid">
        <div class="body-format">
            <div class="container">
                <div class="grid-logo">
                    <img class="logo" src='../../static/images/cumplo-logo.png' alt="cumplo">
                </div>
                <div class="grid-text">
                    <div class="container-text">
                        <h1>Estamos trabajando para ofrecerte un mejor servicio, volvemos pronto.
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'ComingSoon'
}
</script>
<style scoped>

.body-format {
    background: #00ba68;
    margin: 0;
    padding: 0;
    font-family: 'Roboto', sans-serif;
    background: linear-gradient(rgba(0, 186, 104, .75), rgba(0, 186, 104, .75)),
    url(../../static/images/smartmockups.jpg);
    width: 100%;
    height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center right ;
    color: #ffffff
}
.container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, 150px) 1fr;
    color: #ffffff;
    padding: 90px 100px 0px;
}
.logo {
    width: 400px;
}
h1 {
    text-shadow: 0.1em 0.1em 0.3em rgba(0, 0, 0, 0.72);
}
.grid-logo{
    justify-self: center
}

@media (max-width: 824px) {
    body{
        height: 110vh;
    }
    .container {
        display: grid;
        grid-template-columns: auto;
        grid-template-rows: repeat(2, auto);
        padding: 100px 30px 0px;
    }

    h1 {
        text-align: center;
        font-size: 20px;
        line-height: 36px;
        margin: 0;
    }

    p {
        text-align: center;
    }
    .grid-logo {
        justify-self: center
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ComingSoon.vue